import { journeyAction } from "./base";

import { JourneyActionPreChatFormSubmission as JourneyActionStartChatBase } from "atlas-shared";

export const JourneyActionPreChatFormSubmission = journeyAction({
  ...JourneyActionStartChatBase,
  icon: "Chat",
});
